<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Donation Widget Bold Copy</h2>
      <p class="text-sm text-gray-500">
        The big mission statement that swaps per step on the left side of the donation modal.
        One slot per step. Leave a slot blank to fall back to the global default.
      </p>
    </header>

    <div
      v-for="(step, i) in steps"
      :key="step.key"
      class="rounded-lg border border-gray-200 bg-gray-50 p-3"
    >
      <div class="mb-2 flex items-center gap-2">
        <span
          class="inline-flex h-6 w-6 items-center justify-center rounded-full bg-pink-500 text-xs font-semibold text-white"
          aria-hidden="true"
        >{{ i + 1 }}</span>
        <span class="text-xs font-semibold uppercase tracking-wider text-gray-700">
          {{ step.label }}
        </span>
        <span class="text-xs italic text-gray-400">{{ step.role }}</span>
      </div>

      <textarea
        v-model="content.step_copy[i]"
        rows="2"
        maxlength="200"
        :placeholder="defaults[i]"
        class="block w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
      ></textarea>

      <p class="mt-1.5 text-xs text-gray-500">
        <span v-if="content.step_copy[i]">{{ (content.step_copy[i] || '').length }} / 200</span>
        <span v-else class="italic">Default: &ldquo;{{ defaults[i] }}&rdquo;</span>
      </p>
    </div>
  </section>
</template>

<script>
/**
 * Editor for the donation widget's per-step bold copy. Five slots — one
 * for each step in the donate flow (Amount, Card, Match, You, Done).
 * Empty slots fall through to the JS component's hard-coded defaults at
 * render time, so admins only need to override the lines they want
 * different on this campaign.
 *
 * The defaults mirror the array in
 * resources/js/components/make-donation/MakeDonationWidget.vue → impactCopy.
 * Keep these two lists in sync: the editor shows them as placeholders so
 * the admin sees what would render if they leave a field blank.
 */
const STEP_DEFAULTS = [
  'Real research. Real patients. Right now.',
  'Your gift funds personalized cancer treatment.',
  'Athletes funding science. It works.',
  'No person living with MBC should face this alone.',
  'Tomorrows matter. You make them possible.',
];

const STEPS = [
  { key: 'amount', label: 'Amount', role: 'opens the flow — sets the mission' },
  { key: 'card',   label: 'Card',   role: 'anchors the gift to concrete impact' },
  { key: 'match',  label: 'Match',  role: 'frames the employer-match multiplier' },
  { key: 'you',    label: 'You',    role: 'personalizes the donor connection' },
  { key: 'done',   label: 'Done',   role: 'celebrates the completed gift' },
];

export default {
  name: 'DonationWidgetSectionEditor',
  props: {
    content: { type: Object, required: true },
  },
  data() {
    return {
      steps: STEPS,
      defaults: STEP_DEFAULTS,
    };
  },
  created() {
    // Make sure step_copy is always a 5-slot array — the parent's
    // FoundationTemplateContent::donationWidget() already pads, but this
    // guards against malformed data flowing in via discard/reset.
    if (!Array.isArray(this.content.step_copy)) {
      this.content.step_copy = [null, null, null, null, null];
    }
    while (this.content.step_copy.length < 5) {
      this.content.step_copy.push(null);
    }
  },
};
</script>
